module.exports = __webpack_public_path__ + "img/product-placeholder-87.ce615bd.png";